import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import { defaultSeasonRosterExportFieldNames } from "~pages/Roster/components/RosterTable/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportSeasonRoster = (entityId: string) => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();
  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultSeasonRosterExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/entities/${entityId}/roster/export`, {
        method: "POST",
        body,
      });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        notification.success({
          message: formatMessage({ id: "seasonRoster.export.started" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
